import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

export default function BackButton({ onBack, title = 'Zurück', size = 32, force = false }) {
  const { T } = useTheme();
  const [hover, setHover] = useState(false);
  const [pressed, setPressed] = useState(false);
  const sv = Math.round(size * 0.41);
  // Native App: alle Screens sind Ionic-Routen mit nativem Swipe-back → der runde
  // Back-Pfeil ist redundant und entfällt. Web/Desktop behält ihn (kein Swipe).
  // `force` als Notausgang, falls ein Screen den Pfeil doch braucht.
  const isNativeApp = typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
  if (isNativeApp && !force) return null;
  return (
    <button
      onClick={onBack}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setPressed(false); }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      aria-label="Zurück"
      title={title}
      style={{
        width: size, height: size,
        borderRadius: '50%',
        background: hover ? T.itemHover : (T.surfaceHi || 'transparent'),
        border: `1px solid ${hover ? T.text : T.line}`,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer',
        color: hover ? T.text : T.sub,
        flexShrink: 0,
        WebkitTapHighlightColor: 'transparent',
        transform: pressed ? 'scale(0.94)' : 'scale(1)',
        transition: 'background 0.18s ease, color 0.18s ease, border-color 0.18s ease, transform 0.16s cubic-bezier(0.22, 1, 0.36, 1)',
      }}
    >
      <svg width={sv} height={sv} viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.4"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
  );
}
